var modalscroll = document.querySelectorAll('.modal');

modalscroll.forEach(function(modal) {
  new MutationObserver(function(mutations) {
    var display = modal.style.display || getComputedStyle(modal).display;
    if (display === 'block') {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
    }
  }).observe(modal, { attributes: true });
});